import data from './resources.json';
export type Resource = Omit<typeof data[number], 'n8nTemplateUrl'> & { n8nTemplateUrl: string | null };
export const resources: Resource[] = data;
export const resourceFile = (path: string) => `${import.meta.env.BASE_URL}${path.replace(/^\//, '')}`;
